import { getStoreId } from "$/hooks/use-store-information"
import partQueries from "$/lib/queries/part-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/parts")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId)
      queryClient.prefetchQuery(
        partQueries.partsWithDeactivationStatus(storeId),
      )
    return {
      crumbs: "alfred.settings.nav.parts.label",
    }
  },
})
